import { OverlayModule } from '@angular/cdk/overlay';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { CdsTooltipModule } from '../cds-tooltip/cds-tooltip.module';
import { DrilldownChartContainerComponent } from './drilldown-chart-container.component';

@NgModule({
  declarations: [DrilldownChartContainerComponent],
  exports: [DrilldownChartContainerComponent],
  imports: [BrowserModule, CdsTooltipModule, OverlayModule, NgxSkeletonLoaderModule, MatIconModule],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DrilldownChartContainerModule {}
